import React from 'react';
import './Card.css';

// ---------------------------------------------------------------------------
// Card
// ---------------------------------------------------------------------------

export type CardVariant = 'default' | 'nested' | 'info';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    variant?: CardVariant;
}

export const Card: React.FC<CardProps> = ({ variant = 'default', className = '', children, ...rest }) => (
    <div className={`cu-card cu-card--${variant} ${className}`.trim()} {...rest}>
        {children}
    </div>
);

// ---------------------------------------------------------------------------
// CardHeader — title + optional right-side actions slot
// ---------------------------------------------------------------------------

export interface CardHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
    title?: React.ReactNode;
    actions?: React.ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ title, actions, className = '', children, ...rest }) => (
    <div className={`cu-card__header ${className}`.trim()} {...rest}>
        {title != null && <span className="cu-card__title">{title}</span>}
        {children}
        {actions != null && <div className="cu-card__actions">{actions}</div>}
    </div>
);

// ---------------------------------------------------------------------------
// CardBody — adds consistent inner padding
// ---------------------------------------------------------------------------

export const CardBody: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className = '', children, ...rest }) => (
    <div className={`cu-card__body ${className}`.trim()} {...rest}>
        {children}
    </div>
);

// ---------------------------------------------------------------------------
// CardFooter
// ---------------------------------------------------------------------------

export const CardFooter: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className = '', children, ...rest }) => (
    <div className={`cu-card__footer ${className}`.trim()} {...rest}>
        {children}
    </div>
);
